import styled from "styled-components";

interface ProgressProps {
  percentage: number;
}

export const Container = styled.div`
  width: 300px;
  height: 70px;
  overflow: hidden;
`;

export const ProgressBackground = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 10px;
  margin-bottom: 5px;
  background: #ccc;
  overflow: hidden;
`;

export const Progress = styled.div<ProgressProps>`
  width: ${({ percentage }) => `${percentage}%`};
  height: 100%;
  background: #9835d1;
  border-radius: 10px;
  transition: all 0.2s ease-in-out;
`;